'use strict';exports.__esModule = true;var _constants = require('../constants');

var getLocalizedData = function getLocalizedData() {var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var locale = arguments[1];var fallback = arguments[2];
  var localized = data[locale];
  var defaultLocale = data[fallback ? _constants.language.fallback : _constants.language.default];

  return {
    isDefaultLanguage: !localized,
    result: localized || defaultLocale };

};exports.default =

getLocalizedData;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getLocalizedData.js
// module id = 61
// module chunks = 0